export default "__VITE_ASSET__BL6pl10$__"